import {Component, OnInit} from '@angular/core';
import {ModalDismissReasons, NgbModal, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {LoaderService} from '@app/shared/services';
import {OrderService} from '@app/shared/services/order.service';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {NgxPrintDirective} from 'ngx-print';
import {Nl2BrPipe} from '@app/shared/pipe';
import * as numberToWords from 'number-to-words';
import {UtilsInjectable} from '@app/shared';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-purchase-order-list',
  templateUrl: './purchase-order-list.component.html',
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    RouterLink,
    NgbPaginationModule,
    NgxPrintDirective,
    Nl2BrPipe,
    NgOptimizedImage,
    PaginationComponent
  ],
  styleUrls: ['./purchase-order-list.component.scss']
})

export class PurchaseOrderListComponent implements OnInit {

  public user_rights: any;
  public user_data: any = {};
  public now = new Date();
  public order_data: any = [];
  public order: any =
    {
      search_order: '',

    }
  public purchase_order: any =
    {
      order_id: '',
      reference_date: new Date(),
      payment_reference: '',
    }
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  close_reason = '';
  status: any;
  index: any;
  router: any;
  orderd: any;
  closeResult = '';
  public item_list: any = [];
  total = 0;
  list: any;

  orderclose_id = 0;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  numberToWords: any;

  constructor(private loaderService: LoaderService, private modalService: NgbModal, public orderService: OrderService, private toastr: ToastrService, protected utils: UtilsInjectable) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.getorderList();
  }

  public deletePO(data: any) {
    if (confirm("Are you sure to delete this purchase order?")) {
      this.deletePurchaseOrder(data);
    }
  }

  public deletePurchaseOrder(data: any) {
    const postData = {
      order_id: data.PURCHASE_ORDER_ID,
      user_id: this.user_data.user_id
    };
    this.loaderService.display(true);
    this.orderService.deletePurchaseOrder(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.toastr.success(result["msg"])
        this.getsearchlist();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.toastr.error(result["msg"])
      }
    });
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public getorderList(page = 1) {
    this.page = page;
    const limit = 50;
    this.start = (page-1) * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      order_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.orderService.listPurchaseOrder(postData).subscribe((result: any) => {
      this.order_data = result['data'];
      this.collection = result['total_count'];
    });
    this.loaderService.display(false);
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.order.search_order,
      order_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.orderService.listPurchaseOrder(postData).subscribe((result: any) => {
        this.order_data = result['data'];
        this.collection = result['total_count'];
        const i = this.order_data.length;
        this.index = i + 5;
        this.status = result['status'];
        this.loaderService.display(false);
    });
  }

  public clear_search() {
    if (this.order.search_order != '') {
      this.order.search_order = '';
      this.getorderList();
    }
  }

  public purached_order_items(item: any) {
    const postData = {
      order_id: item.PURCHASE_ORDER_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.getOrder(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.orderd = result['data'];
        if (this.orderd) {
          this.numberToWords = (numberToWords.toWords(this.orderd.GRAND_TOTAL));
        }
        this.purchase_order.payment_reference = result['data'].PAYMENT_REFERENCE;
        if (result['data'].REFERENCE_DATE) {
          this.purchase_order.reference_date = result['data'].REFERENCE_DATE;
        } else {
          this.purchase_order.reference_date = new Date();

        }
        this.item_list = result['data'].PURCHASE_ORDER;
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public closeOrder() {

    if (this.orderclose_id != 0 && this.orderclose_id != null && this.close_reason != "" && this.close_reason != null) {
      const postData = {
        order_id: this.orderclose_id,
        close_reason: this.close_reason,
        user_id: this.user_data.user_id
      };

      this.loaderService.display(true);
      window.scrollTo(0, 0);
      this.loaderService.display(true);
      this.orderService.closeOrder(postData).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.toastr.success(result["msg"]);
          this.getorderList();
          this.loaderService.display(false);
        } else {
          this.loaderService.display(false);
        }
      });
    }
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public payment_pop(order_id: any) {
    this.purchase_order.order_id = order_id;
  }

  public savePaymentDetails() {

    if (this.purchase_order.order_id != 0 && this.purchase_order.order_id != null && this.purchase_order.payment_reference != "" && this.purchase_order.payment_reference != null) {
      this.loaderService.display(true);
      window.scrollTo(0, 0);
      this.loaderService.display(true);
      this.orderService.savePaymentDetails(this.purchase_order).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.toastr.success(result["msg"]);
          this.getorderList()
          this.loaderService.display(false);
        } else {
          this.toastr.success(result["msg"]);
          this.loaderService.display(false);
        }
      });
    }
  }

  protected open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected close(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: "custom"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
